import { Card, CardBody, CardHeader, TabPane } from "reactstrap";
import FavDataLoop from "./FavDataLoop";
import ViewBookmark from "../ViewBookmarks";
import { useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { Favorites } from "../../../../Constants/Constants";
import { H5 } from "../../../../AbstractElements";

const FavDataTab = () => {
  const { gridView } = useAppSelector((state)=>state.bookmarkTab)
  return (
    <TabPane tabId="2">
      <Card className="mb-0">
        <CardHeader className="d-flex">
          <H5 className="mb-0">{Favorites}</H5>
          <ViewBookmark />
        </CardHeader>
        <CardBody>
          <div className={`details-bookmark text-center ${gridView ? "" : "list-bookmark"}`}>
            <FavDataLoop />
          </div>
        </CardBody>
      </Card>
    </TabPane>
  );
};

export default FavDataTab;
